.rememberMeControl {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: #16182b;
  font-family: "Inter";
}

.tooltipContainer {
  position: relative;
  flex: 0 0 auto;
}

.tooltipButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #39393a;
  cursor: pointer;
}

.tooltipButton:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.tooltipButton:focus-visible {
  border-radius: 50%;
  outline: 2px solid #16182b;
  outline-offset: 2px;
}

.informationIcon {
  display: block;
  width: 20px;
  height: 20px;
}

.tooltip {
  position: fixed;
  z-index: 3;
  box-sizing: border-box;
  max-width: calc(100vw - 48px);
  padding: var(--tooltip-vertical-padding, 12px) 14px;
  border-radius: 6px;
  background: #16182b;
  color: #ffffff;
  box-shadow: 0 4px 14px rgba(22, 24, 43, 0.24);
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  opacity: 0;
  transform: translateY(-4px);
  transition:
    opacity 140ms ease-out,
    transform 140ms ease-out;
}

.tooltipAbove {
  transform: translateY(4px);
}

.tooltipVisible {
  opacity: 1;
  transform: translateY(0);
}

.tooltipContent {
  max-height: var(--tooltip-content-max-height);
  overflow-y: auto;
}

.tooltip::before {
  position: absolute;
  top: -6px;
  left: var(--tooltip-arrow-left, 10px);
  width: 12px;
  height: 12px;
  background: #16182b;
  content: "";
  pointer-events: none;
  transform: rotate(45deg);
}

.tooltipAbove::before {
  top: auto;
  bottom: -6px;
}

@media (prefers-reduced-motion: reduce) {
  .tooltip {
    transition: none;
  }
}

.tooltip p {
  position: relative;
  margin: 0;
}

.tooltip p + p {
  margin-top: 8px;
}
